import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M14.738 95.469h64.138c0-6.44-5.221-11.661-11.661-11.661H52.638c0-6.44-5.221-11.662-11.661-11.662H14.738"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M35.381 82.196c0-.888.72-1.608 1.608-1.608h24.766a1.608 1.608 0 1 1 0 3.216H36.989c-.888 0-1.608-.72-1.608-1.608"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M72.445 73.346c12.881 0 23.323-10.442 23.323-23.323S85.326 26.7 72.445 26.7 49.122 37.142 49.122 50.023s10.442 23.323 23.323 23.323"
    />
    <path
      fill="#001A43"
      d="M82 54.592c0-4.47-3.212-7.347-8.182-7.347h-3.636c-2.728 0-2.728-1.2-2.728-1.837s0-1.837 2.728-1.837h7.879c1.503 0 2.727-1.236 2.727-2.755s-1.224-2.755-2.727-2.755h-3.334v-.306C74.727 36.237 73.503 35 72 35s-2.727 1.237-2.727 2.755v.343c-4.449.33-7.273 3.135-7.273 7.31 0 4.47 3.212 7.347 8.182 7.347h3.636c2.728 0 2.728 1.2 2.728 1.837s0 1.837-2.728 1.837H65.94c-1.503 0-2.727 1.236-2.727 2.755s1.224 2.755 2.727 2.755h3.334v.306C69.273 63.763 70.497 65 72 65s2.727-1.237 2.727-2.755v-.343c4.449-.33 7.273-3.135 7.273-7.31"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M97.066 83.479a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M112.06 40.633a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#0597A3" d="M17.5 46a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M103.124 14.23a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M91.008 14.23a1.5 1.5 0 0 1 2.122 0l9.994 9.993a1.5 1.5 0 1 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122M30.894 47.286a1.5 1.5 0 0 1 1.5 1.5V62.92a1.5 1.5 0 1 1-3 0V48.786a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M22.327 55.853a1.5 1.5 0 0 1 1.5-1.5H37.96a1.5 1.5 0 0 1 0 3H23.827a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M14.738 97.529V70.083a3.77 3.77 0 0 0-7.54 0v27.444a3.77 3.77 0 0 0 7.54 0"
    />
  </svg>
);
const SvgEnrichedIconPaymentInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPaymentInverted);
export default Memo;
